export const NO_DATA = '-';
export const TOKEN_SYMBOL = 't';
export const ORAIN_PHONE_NUMBER = '+34 938 09 76 29';
